<template>
  <div>
    <QueryFrame
      :count="count"
      :current="page"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>门店名称:</label>
            <storeListSelect
              class="item"
              :multiple="true"
              v-model="query.storeId">
            </storeListSelect>
          </div>
          <div class="queryItem">
            <label>年度:</label>
            <timeStampDatePicker
              class="item"
              placeholder=" 请选择"
              clearable
              type="year"
              v-model.trim="query.yearVal">
            </timeStampDatePicker>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '../../../components/frame/QueryFrame.vue';
import points from '../../../services/points';
import utils from '../../../libs/utils';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins';

export default {
  name: 'prePayment',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  computed: {},
  data() {
    return {
      query: {
        storeId: null,
        yearVal: new Date(),
      },
      columns: [
        { title: '门店名称', key: 'storeName', minWidth: 116 },
        { title: '年度', key: 'yearVal', minWidth: 116 },
        { title: '总积分', key: 'totalAllNum', minWidth: 116 },
        { title: '已使用积分', key: 'totalUsedNum', minWidth: 116 },
        { title: '冻结积分', key: 'totalFrozenNum', minWidth: 116 },
        { title: '可用积分', key: 'totalNum', minWidth: 116 },
      ],
      tableData: [],
    };
  },

  methods: {
    getData() {
      const params = utils.deepClone(this.query);
      params.page = this.page;
      params.size = this.size;
      if (this.query.yearVal) {
        params.yearVal = new Date(this.query.yearVal).getFullYear();
      }
      this.tableData = [];
      points.storePointList(params).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.count = count;
          this.tableData = utils.deepClone(list);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clear() {
      this.query = {};
    },
  },
  created() {
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
.btns{
  margin-bottom: 12px;
  >*{
    margin-right:8px
  }
}
</style>
